'use client';

import React, { createContext, useContext, useState, ReactNode } from 'react';

type ServiceKey = 'analytics' | 'marketing' | 'cro' | 'growthPartner' | 'ai' | 'lookerStudio' | 'multiChannelLooker' | 'oneTimeProject';

interface ServiceContextType {
  selectedService: ServiceKey[];
  setSelectedService: React.Dispatch<React.SetStateAction<ServiceKey[]>>;
}

const ServiceContext = createContext<ServiceContextType | undefined>(undefined);

export const useService = () => {
  const context = useContext(ServiceContext);
  if (context === undefined) {
    throw new Error('useService must be used within a ServiceProvider');
  }
  return context;
};

interface ServiceProviderProps {
  children: ReactNode;
}

export const ServiceProvider: React.FC<ServiceProviderProps> = ({ children }) => {
  const [selectedService, setSelectedService] = useState<ServiceKey[]>([]);

  return (
    <ServiceContext.Provider value={{ selectedService, setSelectedService }}>
      {children}
    </ServiceContext.Provider>
  );
};
